import { createGlobalState } from '@vueuse/core'
import { shallowRef } from 'vue'
import { useSystemInfo } from './index'
import { getLoginBanner } from '@/api/login'

export const useLoginBanner = createGlobalState(
  () => {
    const banner = shallowRef('')
    const language = useSystemInfo().language
    const update = () => {
      getLoginBanner({ language }).then((res) => {
        const { code, data } = res
        if (code == 1 && data) {
          banner.value = data.picture
        }
      })
    }
    return { banner, update }
  }
)